import React from 'react';
import { useAppSelector } from '../../hooks';
import { AppState } from '../../types/AppState';
import { isCarportView } from '../../utils/clientIdUtils';
import { Dashboard } from './Dashboard';
import { Page } from '../library/Page';
import { PageContentCard } from '../library/PageContentCard';
import { PageHeader } from '../library/PageHeader';

const CARPORTS_DASHBOARD_ID = '58';
const SHEDS_DASHBOARD_ID = '56';

export const Analyze: React.FC = () => {
  const clientId = useAppSelector((state: AppState) => state?.clientData.clientId) || '';

  return (
    <Page>
      <PageHeader id="analyze-header" header="Analyze" />
      <PageContentCard sx={{ display: 'flex', flex: 1 }}>
        <Dashboard
          clientId={clientId}
          dashboardId={isCarportView(clientId) ? CARPORTS_DASHBOARD_ID : SHEDS_DASHBOARD_ID}
        />
      </PageContentCard>
    </Page>
  );
};
